import { render } from "./TalkToMyDataInvocations.vue?vue&type=template&id=1acc50aa&scoped=true"
import script from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"

import "./TalkToMyDataInvocations.vue?vue&type=style&index=0&id=1acc50aa&scoped=true&lang=css"
import "./TalkToMyDataInvocations.vue?vue&type=style&index=1&id=1acc50aa&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acc50aa"]])

export default __exports__